/**
 * lib/objectHealth.js — Iter 53 client helper.
 *
 * Single source for fetching + caching object health. Calls the new
 * /api/objects/{type}/{id}/health endpoint. Stores the latest result
 * in localStorage so when offline we can render "Last known health"
 * without errors or broken spinners (Phase 9).
 */
import { api } from "@/lib/api";

const STATE_LABEL = {
  healthy: "Healthy",
  closed: "Closed",
  attention_needed: "Attention Needed",
  pending_verification: "Pending Verification",
  action_required: "Action Required",
};

const STATE_TONE = {
  healthy: "var(--st-completed, #10b981)",
  closed: "var(--st-completed, #10b981)",
  attention_needed: "var(--st-pending, #f59e0b)",
  pending_verification: "#0ea5e9",
  action_required: "var(--st-escalated, #ef4444)",
};

export function healthLabel(state) {
  return STATE_LABEL[state] || "Healthy";
}

export function healthTone(state) {
  return STATE_TONE[state] || STATE_TONE.healthy;
}

const _key = (objectType, objectId) =>
  `fop_health_${objectType}_${objectId}`;

export async function fetchObjectHealth(objectType, objectId) {
  try {
    const { data } = await api.get(
      `/objects/${objectType}/${objectId}/health`);
    try {
      localStorage.setItem(_key(objectType, objectId), JSON.stringify({
        ...data, _fetched_at: Date.now(),
      }));
    } catch { /* quota etc — fine */ }
    return { online: true, data };
  } catch (e) {
    // Offline / network failure → return cached last-known
    let cached = null;
    try {
      const raw = localStorage.getItem(_key(objectType, objectId));
      if (raw) cached = JSON.parse(raw);
    } catch { /* ignore */ }
    return { online: false, data: cached, error: e?.message };
  }
}
